/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

// import views
import Home from "./views/Home.vue";
import About from "./views/About";
import FourOhFour from "./views/FourOhFour";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
    {
      path: "/*",
      component: FourOhFour,
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js